<!--
 * @Description:    通用选择框组件
 * @Version: 1.0
 * @Author: tu
 * @Date: 2024-02-01 16:38:39
 * @LastEditors: tu
 * @LastEditTime: 2024-04-08 14:43:44
 * @FilePath: /clinic-home-web/src/components/select-input-common.vue
-->
<template>
  <div class='select-input-common'>
    <el-popover ref="popoverRef"
      v-bind="{ placement: 'bottom-start', trigger: 'click', width: 'auto', ...popoverAttrs }"
      v-if="!inputConfig.disabled" :disabled="optionsCopy.length < 2 && isShowArrow">
      <template slot="reference">
        <div style="position: relative;">
          <el-input v-model="inputValue" v-bind="{ placeholder: '请选择', readonly: true, ...inputConfig }" style="min-width: 40px;" />
          <div style="position: absolute; top: -8px; right: -3px;" v-if="optionsCopy.length > 1 && isShowArrow">
            <i class="el-icon-caret-bottom"></i>
          </div>
        </div>
      </template>
      <div class="select-popover"
        :style="{ 'grid-template-columns': `repeat(${rowNumber}, 1fr)`, '--row-number': rowNumber }">
        <div class="select-popover-option" @click.stop="select(item)" v-for="(item, i) in optionsCopy"
          :class="{ 'active': getSelectKey(item) === selectValue, 'is-disabled': item.disabled }"
          :key="getSelectKey(item) + i">
          {{ getSelectLabel(item) }}
        </div>
      </div>
    </el-popover>
    <el-input v-model="inputValue" v-bind="{ placeholder: '请选择', readonly: true, ...inputConfig }" v-else />
  </div>
</template>

<script>
export default {
  name: 'SelectInputCommon',
  props: {
    // 选中的值
    value: {
      type: [String, Number, null, undefined],
      default: ''
    },
    // 可选项列表
    options: {
      type: Array,
      default: () => []
    },
    // input配置
    inputConfig: {
      type: Object,
      default: () => { }
    },
    // popover配置
    popoverAttrs: {
      type: Object,
      default: () => { }
    },
    // 获取tab列表唯一key的方法
    getKey: {
      type: [String, Function],
      default: (tab) => tab.key
    },
    // 获取tab列表唯一label的方法
    getLabel: {
      type: [String, Function],
      default: (tab) => tab.label
    },
    // 行个数
    rowNumber: {
      type: Number,
      default: 4
    },
    // 是否远程搜索
    remote: {
      type: Boolean,
      default: false
    },
    // 是否允许用户创建新条目
    allowCreate: {
      type: Boolean,
      default: false
    },
    // 远程搜索方法
    fetchSuggestions: {
      type: Function,
      default: () => { }
    },
    isShowArrow: {
      type: Boolean,
      default: false
    },
    types: {
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      inputValue: '',
      optionsConfig: [],
      popoverRef: this.$refs.popoverRef
    };
  },
  computed: {
    selectValue: {  // 选中key
      get () {
        return this.value;
      },
      set (value) {
        this.$emit('update:value', value);
      }
    },
    popoverShow () {
      return !!this.popoverRef && this.popoverRef.showPopper
    },
    optionsCopy () {
      if (this.optionsConfig.length === 0) {
        return this.options;
      } else {
        return this.optionsConfig;
      }
    },
  },
  methods: {
    change () {
      let row = this.optionsCopy.find(item => this.getSelectKey(item) === this.inputValue);
      this.$emit('change', row || {});
    },
    getSelectKey (item) {
      if (typeof this.getKey === 'function') {
        return this.getKey(item);
      } else {
        return item[this.getKey];
      }
    },
    getSelectLabel (item) {
      if (typeof this.getLabel === 'function') {
        return this.getLabel(item);
      } else {
        return item[this.getLabel];
      }
    },
    selectPopover () {
      // this.popoverShow = true
    },
    // 关闭
    closePopover () {
      // this.popoverShow = false;
      // this.inputValue = this.getSelectLabel(this.options.find(item => this.getSelectKey(item) === this.selectValue) || {});
    },
    async select (row) {
      if (row.disabled) {
        return;
      }
      this.inputValue = this.getSelectLabel(row || {});
      this.selectValue = this.getSelectKey(row || {});
      // this.popoverShow = false;
      this.doClose()
      await this.$nextTick();
      let v = this.optionsCopy.find(item => item.value === this.selectValue) || {};
      this.$emit('change', this.selectValue, v.enValue || null);
      if (this.types) {
        // 用药频率要的
        this.$emit('setEnValue', v.enValue || null);
      }
    },
    doClose () {
      this.$refs.popoverRef.doClose()
    },
    doToggle () {
      this.$refs.popoverRef.doToggle()
    },
    doShow () {
      this.$refs.popoverRef.doShow()
    },
    cb (data) {
      this.optionsConfig = data;
    },
  },
  // 监听activeList的变化，更新modelValue
  watch: {
    selectValue: {
      handler (value) {
        let row = this.optionsCopy.find(item => item.value === value) || {};
        this.$emit('change', value, row.enValue || null);
        if (this.types) {
          // 用药频率要的
          this.$emit('setEnValue', row.enValue || null);
        }
      }
    },
    popoverShow: {
      handler (value) {
        if (value) {
          // this.$emit('fetchSuggestions', this.inputValue, this.cb);
          this.fetchSuggestions(this.inputValue, this.cb)
        } else {
          if (this.allowCreate) {

            this.selectValue = this.inputValue || this.selectValue;
            this.$emit('create', this.inputValue);
          } else {
            this.inputValue = this.getSelectLabel(this.optionsCopy.find(item => this.getSelectKey(item) === this.selectValue) || {}) || this.selectValue;
          }
        }
      },
      deep: true
    },
    inputValue: {
      handler (value) {
        this.selectValue = value
        if (this.popoverShow) {
          this.fetchSuggestions(this.inputValue, this.cb)
        }
      }
    },
    optionsCopy: {
      handler (value) {
        if (!this.popoverShow) {
          this.inputValue = this.getSelectLabel(value.find(item => this.getSelectKey(item) === this.selectValue) || {}) || this.selectValue;
        }
      },
      deep: true
    },
    value: {
      handler (value) {
        this.inputValue = this.getSelectLabel(this.options.find(item => this.getSelectKey(item) === value) || {}) || value;
      },
      immediate: true
    }
  },
  // 组件挂载时初始化activeName
  mounted () {
    this.popoverRef = this.$refs.popoverRef;
  },
  updated () {
    // this.popoverRef = this.$refs.popoverRef;
    // 
    // this.inputValue = this.getSelectLabel(this.options.find(item => this.getSelectKey(item) === this.selectValue));
  }
};
</script>

<style scoped lang="scss">
.select-input-common {
  // width: 100%;
  // height: 100%;

}

.select-popover {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border: 1px solid #ebeef5;

  .select-popover-option {
    padding: 10px;
    cursor: pointer;
    border: 1px solid #ebeef5;
    text-align: center;
    padding: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      background-color: #cef0edbd;
      color: #72d1c9;
    }
  }

  .active {
    color: #1ba79c !important;
    background-color: #83e8e0bd !important;
  }

  .is-disabled {
    cursor: not-allowed !important;
    background-color: #f5f7fa !important;
    color: #c0c4cc !important;

  }

}
</style>
